import { BrowserInformation } from "@models/BookingBrowserInformation";
import * as SellRequest from "@models/SellRecommendationQuery";

import { BaggageAncillaryBooking } from "./baggage-ancillary-booking";

export class FlightBooking {
  features: string;
  CancellationInfo: string;
  penalities: string;
  ATCInfo: string;
  selectedFlightObject: any;
  newRequestId: any;
  carrier: string;
  supplierCode: string;
  codeShareCarrier: String;
  segmentCount: number = 0;
  itineraryDetails: any;
  passengerList: PassengersDetails;
  userAddresses: Array<CustomerAddress> = [];
  bookingPayment: BookingPayment;
  additionalBookingDetails: BookingDetailsRequest;
  creditCard: CreditCard;
  tfBookingDetails: TFBookingDetails;
  asBookingDetails: AsBookingDetails;
  fareRulesFareBasis: Array<FareRulesFareBasis> = [];
  frequentFlyer: { type: string; value: string; flyerNo: string };
  amadeusSession: AmadeusSession;
  freeBaggageAllowance: BaggageAllowance;
  airlineCoupon: AirlineCoupon;
  browserInformation: BrowserInformation;
  uniqueOfferReferenceID: any;
  shoppingResponseRefID: any;
  selectedOfferItemGroup: Array<any>;
  consolidatorCode: string;

  prepareFlightBooking(model: FlightBooking, formObj, specialService, adtIdx: Array<any> = [], originDestinationOptions: any, userObj, ipaddress, isDomestic: boolean = false) {
    let sellRequestModel = new SellRequest.SellRecommendationQuery();
    let tripDtls = formObj.flightInfo.flghttripDtls;
    let flightDtls = formObj.flightDetails;
    let fareDtls: any[] = [];
    let tfbookDtls: TFBookingDetails = null;
    let asbookDtls = new AsBookingDetails();
    let baggageInfo = new BaggageAllowance();

    let priceType;

    model.newRequestId = formObj.flightInfo.newRequestId;

    model.uniqueOfferReferenceID = formObj.flightInfo.uniqueOfferReferenceID;
    model.shoppingResponseRefID = formObj.flightInfo.shoppingResponseRefID;
    model.selectedOfferItemGroup = formObj.flightInfo.selectedOfferItemGroup;

    model.browserInformation = new BrowserInformation();
    if (formObj.browserInformation) {
      model.browserInformation.browserName = formObj?.browserInformation?.browser?.name;
      model.browserInformation.browserVersion = formObj?.browserInformation?.browser?.version;
      model.browserInformation.osName = formObj?.browserInformation?.os?.name;
      model.browserInformation.osVersion = formObj?.browserInformation?.os?.version;
      model.browserInformation.osVersionName = formObj?.browserInformation?.os?.versionName;
      model.browserInformation.platform = formObj?.browserInformation?.platform?.type;
    }
    model.supplierCode = tripDtls.tripType != "MultiCity" ? flightDtls.depflight.supplierCode : flightDtls[0].depflight.supplierCode;
    model.consolidatorCode = tripDtls.tripType != "MultiCity" ? flightDtls.depflight.consolidatorCode : flightDtls[0].depflight.consolidatorCode;
    model.carrier = formObj.flightInfo.carrier;
    model.itineraryDetails = sellRequestModel.prepareSellRequest(sellRequestModel, tripDtls, flightDtls, originDestinationOptions);
    model.frequentFlyer = formObj.frequentFlyer;
    model.amadeusSession = formObj.flightInfo.session;

    if (model.supplierCode == "TF") {
      tfbookDtls = new TFBookingDetails();
      tfbookDtls.paymentCardTypes = formObj.flightInfo.paymentCards;
      tfbookDtls.carrierName = flightDtls.depflight.flightDetails[0].airlineName;
    }

    let baggageDetailsToBooking;

    if (tripDtls.tripType == "OneWay") {
      console.log(JSON.stringify(flightDtls.depflight.fareDetails));

      fareDtls = flightDtls.depflight.fareDetails.passengerFareDetails;
      asbookDtls.fareTypes = flightDtls.depflight.fareDetails.fareTypes;
      asbookDtls.fareRules = "";
      asbookDtls.fareBasis = flightDtls.depflight.fareDetails.fareBasis;
      asbookDtls.brandId = flightDtls.depflight.fareDetails.brandId;

      priceType = flightDtls.depflight.priceType;

      baggageDetailsToBooking = flightDtls?.depflight?.fareDetails?.baggageDetails ? flightDtls?.depflight?.fareDetails?.baggageDetails : flightDtls?.depflight?.baggageDetails;

      if (baggageDetailsToBooking) {
        baggageInfo.bagWeightinKG = baggageDetailsToBooking?.["weightInKG"];
        baggageInfo.bagWeightinPounds = baggageDetailsToBooking?.["weightInPounds"];
        baggageInfo.flightFreeBagQuantityCode = baggageDetailsToBooking?.["quantityCode"];
        baggageInfo.flightNoOfFreeBags = baggageDetailsToBooking?.["freeAllowance"];
        baggageInfo.baggageDescription = baggageDetailsToBooking?.["baggageDescription"];
        baggageInfo.segmentBaggage = baggageDetailsToBooking?.["segmentBaggage"];
      } else {
        baggageInfo = null;
      }

      model.codeShareCarrier = flightDtls.depflight.fareDetails.codeShareCompanyDetails;
      model.features = JSON.stringify(flightDtls.depflight.fareDetails?.priceClassLists?.features);
      model.penalities = JSON.stringify(flightDtls.depflight.fareDetails?.penalities);

      model.CancellationInfo = JSON.stringify(flightDtls.depflight.fareDetails?.cancellationInfo);
      model.ATCInfo = JSON.stringify(flightDtls.depflight.fareDetails?.atcInfo);
      model.fareRulesFareBasis = flightDtls.depflight.fareDetails?.fareRulesFareBasis;
      if (model.supplierCode == "TF") {
        tfbookDtls.routingId = flightDtls.depflight.routingId;
        tfbookDtls.outwardId = flightDtls.depflight.outwardId;
        tfbookDtls.returnId = flightDtls.depflight.returnId || null;
      }
    } else if (tripDtls.tripType == "RoundTrip") {
      model.penalities = JSON.stringify(flightDtls.arrivalflight.fareDetails?.penalities);

      model.features = JSON.stringify(flightDtls.arrivalflight.fareDetails?.priceClassLists?.features);

      model.CancellationInfo = JSON.stringify(flightDtls.arrivalflight.fareDetails?.cancellationInfo);
      model.ATCInfo = JSON.stringify(flightDtls.arrivalflight.fareDetails?.atcInfo);
      model.fareRulesFareBasis = flightDtls.arrivalflight.fareDetails?.fareRulesFareBasis;

      fareDtls = flightDtls.arrivalflight.fareDetails.passengerFareDetails;
      asbookDtls.fareTypes = flightDtls.arrivalflight.fareDetails.fareTypes;
      asbookDtls.fareRules = "";
      asbookDtls.fareBasis = flightDtls.arrivalflight.fareDetails.fareBasis;
      asbookDtls.brandId = flightDtls.arrivalflight.fareDetails.brandId;

      model.codeShareCarrier = flightDtls.arrivalflight.fareDetails.codeShareCompanyDetails;

      baggageDetailsToBooking = flightDtls?.arrivalflight?.fareDetails?.baggageDetails ? flightDtls?.arrivalflight?.fareDetails?.baggageDetails : flightDtls?.arrivalflight?.baggageDetails;

      if (baggageDetailsToBooking) {
        baggageInfo.bagWeightinKG = baggageDetailsToBooking?.["weightInKG"];
        baggageInfo.bagWeightinPounds = baggageDetailsToBooking?.["weightInPounds"];
        baggageInfo.flightFreeBagQuantityCode = baggageDetailsToBooking?.["quantityCode"];
        baggageInfo.flightNoOfFreeBags = baggageDetailsToBooking?.["freeAllowance"];
        baggageInfo.baggageDescription = baggageDetailsToBooking?.["baggageDescription"];
        baggageInfo.segmentBaggage = baggageDetailsToBooking?.["segmentBaggage"];
      } else {
        baggageInfo = null;
      }

      if (model.supplierCode == "TF") {
        tfbookDtls.routingId = flightDtls.arrivalflight.routingId;
        tfbookDtls.outwardId = flightDtls.arrivalflight.outwardId;
        tfbookDtls.returnId = flightDtls.arrivalflight.returnId || null;
      }
      priceType = flightDtls.arrivalflight.priceType;
    } else {
      priceType = flightDtls[flightDtls.length - 1].depflight.priceType;

      fareDtls = flightDtls[flightDtls.length - 1].depflight.fareDetails.passengerFareDetails;

      asbookDtls.fareTypes = flightDtls[flightDtls.length - 1].depflight.fareDetails.fareTypes;
      asbookDtls.fareRules = "";
      asbookDtls.brandId = flightDtls[flightDtls.length - 1].depflight.fareDetails.brandId;

      asbookDtls.fareBasis = flightDtls[flightDtls.length - 1].depflight.fareDetails.fareBasis;
      model.codeShareCarrier = flightDtls[flightDtls.length - 1].depflight.codeShareCompanyDetails;
      model.fareRulesFareBasis = flightDtls[flightDtls.length - 1].depflight.fareDetails?.fareRulesFareBasis;

      baggageDetailsToBooking = flightDtls[flightDtls.length - 1]?.depflight?.fareDetails?.baggageDetails
        ? flightDtls[flightDtls.length - 1]?.depflight?.fareDetails?.baggageDetails
        : flightDtls[flightDtls.length - 1]?.depflight?.baggageDetails;

      if (baggageDetailsToBooking) {
        baggageInfo.bagWeightinKG = baggageDetailsToBooking?.["weightInKG"];
        baggageInfo.bagWeightinPounds = baggageDetailsToBooking?.["weightInPounds"];
        baggageInfo.flightFreeBagQuantityCode = baggageDetailsToBooking?.["quantityCode"];
        baggageInfo.flightNoOfFreeBags = baggageDetailsToBooking?.["freeAllowance"];
        baggageInfo.baggageDescription = baggageDetailsToBooking?.["baggageDescription"];
        baggageInfo.segmentBaggage = baggageDetailsToBooking?.["segmentBaggage"];
      } else {
        baggageInfo = null;
      }
    }

    model.asBookingDetails = asbookDtls;
    model.tfBookingDetails = tfbookDtls;
    model.freeBaggageAllowance = baggageInfo;

    let addressArray = [];
    if (formObj.addressType == 1) {
      addressArray.push({ type: 5, address: formObj.billingaddress });
    } else {
      addressArray.push({ type: 2, address: formObj.billingaddress });
      addressArray.push({ type: 3, address: formObj.personaladdress });
    }

    for (let address of addressArray) {
      let customerAddr = new CustomerAddress();
      let customerAddress: CustomerAddress = customerAddr.prepareCustomerAddress(customerAddr, address, userObj);
      model.userAddresses.push(customerAddress);
    }

    /** Booking Payment Start */
    let bookingPaymentModel = new BookingPayment();
    let totalAmountToCharge = 0.0;
    let airlineCoupon: AirlineCoupon = null;

    if (formObj.flightInfo.couponObj != null && formObj.flightInfo.couponObj != undefined) {
      console.log(JSON.stringify(formObj.flightInfo.couponObj));
      console.log(JSON.stringify(formObj.flightInfo.couponObj.isFlightCoupon));
      totalAmountToCharge = parseFloat(formObj.flightInfo.totalAmtPayableWhenCouponApplied.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
      airlineCoupon = new AirlineCoupon();
      if (formObj.flightInfo.couponObj.isFlightCoupon) {
        model.airlineCoupon = airlineCoupon.prepareCoupon(airlineCoupon, formObj.flightInfo.couponObj);
      }
    } else {
      totalAmountToCharge = parseFloat(formObj.flightInfo.totalAmtPayable.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
    }

    if (formObj.creditcard != undefined) {
      let creditCardObj = new CreditCard();
      creditCardObj.cardNumber = formObj.creditcard["cardnumber"].replace(/-/g, "");
      creditCardObj.expirationDate = formObj.creditcard["expiryMonth"] + formObj.creditcard["expiryYear"].substring(2);
      creditCardObj.cardCode = formObj.creditcard["cvv"];
      creditCardObj.cardCode = formObj.creditcard["cvv"];
      creditCardObj.nameOnCard = formObj.creditcard["cardname"];
      creditCardObj.cardType = formObj.creditcard["cardType"];
      bookingPaymentModel.creditCard = creditCardObj;
      bookingPaymentModel.createBookingPayment(bookingPaymentModel, formObj.flightInfo.fareDetails, formObj.flightInfo.currency, null, formObj.flightInfo["couponObj"]);
    } else {
      bookingPaymentModel.createBookingPayment(bookingPaymentModel, formObj.flightInfo.fareDetails, formObj.flightInfo.currency, formObj.paymentMethod, formObj.flightInfo["couponObj"]);
    }

    bookingPaymentModel.ytbPaymentTotalCharge = totalAmountToCharge;
    bookingPaymentModel.totalAmountWithOutCoupon = formObj.flightInfo.totalAmtPayable;
    bookingPaymentModel.conversionCurrencyCode = formObj.flightInfo.convertedCurrency;
    bookingPaymentModel.conversionValue = formObj.flightInfo.convertedAmount;
    bookingPaymentModel.conversionRate = formObj.flightInfo.conversionRate;

    bookingPaymentModel.fromConversionCurrencyCode = formObj.flightInfo.fromConversionCurrencyCode;
    bookingPaymentModel.toConversionCurrencyCode = formObj.flightInfo.toConversionCurrencyCode;
    bookingPaymentModel.fromConversionRate = formObj.flightInfo.fromConversionRate;
    bookingPaymentModel.toConversionRate = formObj.flightInfo.toConversionRate;

    model.bookingPayment = bookingPaymentModel;

    /** Booking Payment End */

    let bookingDtlsRequest = new BookingDetailsRequest();
    let bookDetailObj = {
      supplierCode: tripDtls.tripType != "MultiCity" ? flightDtls.depflight.supplierCode : flightDtls[0].depflight.supplierCode,
      cardType: formObj.creditcard != undefined ? 1 : 0,
      ctryISO2: formObj.billingaddress.country,
      isRefund: formObj.flightInfo.fareDetails.refundable,
      fareRules: formObj.flightInfo.fareDetails.refundDescription,
      tripDtls: tripDtls,
      emergencyContact: formObj.emergencycontact,
      tempReferenceIdNo: formObj.tempReferenceIdNo,
      consolidatorCode: tripDtls.tripType != "MultiCity" ? flightDtls.depflight.consolidatorCode : flightDtls[0].depflight.consolidatorCode,
    };
    bookingDtlsRequest.createBookingDetailsRequest(bookingDtlsRequest, bookDetailObj, formObj, userObj, ipaddress, isDomestic);

    bookingDtlsRequest.bookingClass = tripDtls.tripType != "MultiCity" ? flightDtls.depflight.bookingSeatClass : flightDtls[0].depflight.bookingSeatClass;
    bookingDtlsRequest.bookingType = priceType;

    model.additionalBookingDetails = bookingDtlsRequest;
    let location = JSON.parse(localStorage.getItem("geolocation"));
    model.passengerList = new PassengersDetails();
    for (let i = 0; i < tripDtls.numberOfInfant; i++) {
      formObj.passengers[0].adultpsgrs[i] = [];
    }

    console.log(JSON.stringify(fareDtls), "  *********************");

    let passengers = formObj.passengers[0];
    let adtWithInfPsgrs: any[] = formObj.adultWithInfantDetails;
    let adultTicketPriceArray = fareDtls.filter((x) => x.passengerType == "ADT");
    let childTicketPriceArray = fareDtls.filter((x) => x.passengerType == "CNN" || x.passengerType == "CHD");
    let infantTicketPriceArray = fareDtls.filter((x) => x.passengerType == "INF");
    let segmentArr: number[] = [];
    let isLeadTravellerWithInf: boolean = false;
    let counter = 0;
    let adtindex = 0;

    console.log(JSON.stringify(adultTicketPriceArray));
    console.log(JSON.stringify(childTicketPriceArray));
    console.log(JSON.stringify(infantTicketPriceArray));

    model.itineraryDetails.forEach((item) => {
      item.segmentInformation.forEach((element, i) => {
        segmentArr.push(i + 1);
        model.segmentCount++;
      });
    });

    console.log(passengers.adultpsgrs.length, JSON.stringify(passengers.adultpsgrs));
    if (passengers.adultpsgrs.length) {
    }

    console.log(bookDetailObj.supplierCode, JSON.stringify(location));

    for (let psgr of passengers.adultpsgrs) {
      console.log(JSON.stringify(psgr));

      let item: boolean;
      let adtwithinfindex = 0;
      for (let adtwthinf of adtWithInfPsgrs) {
        if (adtIdx[adtwithinfindex] && adtIdx[adtwithinfindex].adultIndex == adtindex) {
          item = true;
          if (counter == 0) {
            adtwthinf.adultDetails["IsLeadTraveller"] = true;
            adtwthinf.adultDetails["emergencyPhoneNumber"] = formObj.emergencycontact.phone;
            adtwthinf.adultDetails["emergencyPhoneISO2"] = formObj.emergencycontact.phonecode;
            adtwthinf.adultDetails["emergencyEmailID"] = formObj.emergencycontact.email;
            adtwthinf.adultDetails["emergencyRelationCode"] = parseInt(formObj.emergencycontact.relationCode);
            adtwthinf.adultDetails["emergencyFirstName"] = formObj.emergencycontact.firstname;
            adtwthinf.adultDetails["emergencyLastName"] = formObj.emergencycontact.lastname;
            isLeadTravellerWithInf = true;
          } else {
            adtwthinf.adultDetails["IsLeadTraveller"] = false;
          }
        } else {
          // item = false;
        }

        adtwithinfindex++;
      }

      if (!item) {
        let psgrInfo = new PassengerInfo();
        psgrInfo.firstName = psgr.firstname;
        psgrInfo.surname = psgr.lastname;
        psgrInfo.middlename = psgr?.middlename;
        psgrInfo.gender = psgr.gender == 1 ? "male" : "female";
        psgrInfo.dob = psgr.dob;
        psgrInfo.knownTravelerNumber = psgr.knownTravelerNumber;
        psgrInfo.ktnIssuedCountry = psgr.ktnIssuedCountry;
        // tripDtls.tripType != 'MultiCity' ? flightDtls.depflight.supplierCode : flightDtls[0].depflight.supplierCode;

        if (psgr.passport) {
          psgrInfo.passportNumber = psgr.passport;
          psgrInfo.passportExpiryDate = psgr.passportexpirydate;
          psgrInfo.passportIssuePlace = psgr.passportissue;
          psgrInfo.nationality = psgr.nationality;
        } else {
          if (bookDetailObj.supplierCode == "TF") {
            psgrInfo.nationality = location.countryCode ? location.countryCode : "US";
          }
        }

        /* Meal and Wheel Chair SSR & Ancillary Info */
        let adultssr = [];

        psgr.specialservices.forEach((item, index) => {
          if ((item.mealtype != "" && item.mealtype != null) || (item.wheelchairtype != "" && item.wheelchairtype != null) || (item.seatNo != "" && item.seatNo != null)) {
            let ssr = new SSRDetails();
            let ssrinfo = ssr.prepareSSR(ssr, item, tripDtls, index);
            adultssr.push(ssrinfo);
          }
        });

        psgrInfo.ssrDetails = adultssr;
        psgrInfo.ancillaryServices = psgr.ancillaryServices;

        console.log("== phone code ==", psgr.phonecode);
        /* Meal and wheel chair SSR info end */
        if (psgr.phonecode != undefined) {
          psgrInfo.phoneCountryISO2 = psgr.phonecode.value;
          if (psgr.phonecode.phonecode != undefined) {
            psgrInfo.mobileNumber = psgr.phonecode.phonecode + "-" + psgr.phone;
          } else {
            psgrInfo.mobileNumber = psgr.phonecode + "-" + psgr.phone;
          }

          psgrInfo.mailId = psgr.email;
        }
        if (adultTicketPriceArray && adultTicketPriceArray.length > 0) {
          // Temp

          if (adultTicketPriceArray && adultTicketPriceArray[0]?.totalFareAmount) {
            let ticket_price_per_psgr = adultTicketPriceArray[0]?.totalFareAmount;
            psgrInfo.ticketPrice = parseFloat(ticket_price_per_psgr.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
          }
          if (adultTicketPriceArray && adultTicketPriceArray[0]?.totalTaxAmount) {
            let ticket_tax_per_psgr = adultTicketPriceArray[0]?.totalTaxAmount;
            psgrInfo.ticketTax = parseFloat(ticket_tax_per_psgr.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
          } else {
            psgrInfo.ticketTax = 0.0;
          }
        } // Temp
        Object.keys(psgrInfo).forEach((key) => {
          if (key === "knownTravelerNumber") return;
          if (key === "ktnIssuedCountry") return;
          if (psgrInfo[key] === "" || psgrInfo[key] === null || psgrInfo[key] === undefined) {
            delete psgrInfo[key];
          }
        });

        if (counter == 0) {
          psgrInfo.IsLeadTraveller = true;
          psgrInfo.emergencyPhoneNumber = formObj.emergencycontact.phone;
          psgrInfo.emergencyPhoneISO2 = formObj.emergencycontact.phonecode;
          psgrInfo.emergencyEmailID = formObj.emergencycontact.email;

          psgrInfo.emergencyRelationCode = parseInt(formObj.emergencycontact.relationCode);
          psgrInfo.emergencyFirstName = formObj.emergencycontact.firstname;
          psgrInfo.emergencyLastName = formObj.emergencycontact.lastname;
        } else {
          psgrInfo.IsLeadTraveller = false;
        }

        model.passengerList.adultDetails.push(psgrInfo);
      }

      counter++;
      adtindex++;
    }

    for (let psgr of passengers.childpsgrs) {
      let psgrInfo = new PassengerInfo();
      psgrInfo.firstName = psgr.firstname;
      psgrInfo.surname = psgr.lastname;
      psgrInfo.middlename = psgr?.middlename;

      psgrInfo.gender = psgr.gender == 1 ? "male" : "female";
      psgrInfo.dob = psgr.dob;
      psgrInfo.knownTravelerNumber = psgr.knownTravelerNumber;
      psgrInfo.ktnIssuedCountry = psgr.ktnIssuedCountry;
      if (psgr.passport) {
        psgrInfo.passportNumber = psgr.passport;
        psgrInfo.passportExpiryDate = psgr.passportexpirydate;
        psgrInfo.passportIssuePlace = psgr.passportissue;
        psgrInfo.nationality = psgr.nationality;
      } else {
        if (bookDetailObj.supplierCode == "TF") {
          psgrInfo.nationality = location.countryCode ? location.countryCode : "US";
        }
      }

      /* Meal and Wheel Chair SSR Info */

      let childssr = [];
      psgr.specialservices.forEach((item, index) => {
        if ((item.mealtype != "" && item.mealtype != null) || (item.wheelchairtype != "" && item.wheelchairtype != null) || (item.seatNo != "" && item.seatNo != null)) {
          let ssr = new SSRDetails();
          let ssrinfo = ssr.prepareSSR(ssr, item, tripDtls, index);
          childssr.push(ssrinfo);
        }
      });

      psgrInfo.ssrDetails = childssr;
      psgrInfo.ancillaryServices = psgr.ancillaryServices;

      // psgrInfo.phoneCountryISO2 = psgr.phonecode.value;
      // psgrInfo.mobileNumber = psgr.phonecode.phonecode + '-' + psgr.phone;
      psgrInfo.mailId = psgr.email;
      if (childTicketPriceArray && childTicketPriceArray.length > 0) {
        if (childTicketPriceArray && childTicketPriceArray[0]?.totalFareAmount) {
          let ticket_price_per_psgr = childTicketPriceArray[0].totalFareAmount;
          psgrInfo.ticketPrice = parseFloat(ticket_price_per_psgr.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
        }
        if (childTicketPriceArray && childTicketPriceArray[0]?.totalTaxAmount) {
          let ticket_tax_per_psgr = childTicketPriceArray[0].totalTaxAmount;
          psgrInfo.ticketTax = parseFloat(ticket_tax_per_psgr.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
        } else {
          psgrInfo.ticketTax = 0.0;
        }
      }

      Object.keys(psgrInfo).forEach((key) => {
        if (key === "knownTravelerNumber") return;
        if (key === "ktnIssuedCountry") return;
        if (psgrInfo[key] === "" || psgrInfo[key] === null || psgrInfo[key] === undefined) {
          delete psgrInfo[key];
        }
      });

      model.passengerList.childDetails.push(psgrInfo);
    }

    for (let psgr of formObj.adultWithInfantDetails) {
      let adtpsgrInfo = new PassengerInfo();
      adtpsgrInfo.firstName = psgr.adultDetails.firstname;
      adtpsgrInfo.surname = psgr.adultDetails.lastname;
      adtpsgrInfo.middlename = psgr?.adultDetails?.middlename;

      adtpsgrInfo.gender = psgr.adultDetails.gender == 1 ? "male" : "female";
      adtpsgrInfo.dob = psgr.adultDetails.dob;
      adtpsgrInfo.knownTravelerNumber = psgr?.adultDetails?.knownTravelerNumber;
      adtpsgrInfo.ktnIssuedCountry = psgr?.adultDetails?.ktnIssuedCountry;

      if (psgr.adultDetails.passport) {
        adtpsgrInfo.passportNumber = psgr.adultDetails.passport;
        adtpsgrInfo.passportExpiryDate = psgr.adultDetails.passportexpirydate;
        adtpsgrInfo.passportIssuePlace = psgr.adultDetails.passportissue;
        adtpsgrInfo.nationality = psgr.adultDetails.nationality;
      } else {
        if (bookDetailObj.supplierCode == "TF") {
          adtpsgrInfo.nationality = location.countryCode ? location.countryCode : "US";
        }
      }

      /* Meal and Wheel Chair SSR Info */
      let adultssr = [];
      psgr.adultDetails.specialservices.forEach((item, index) => {
        if ((item.mealtype != "" && item.mealtype != null) || (item.wheelchairtype != "" && item.wheelchairtype != null) || (item.seatNo != "" && item.seatNo != null)) {
          let ssr = new SSRDetails();
          let ssrinfo = ssr.prepareSSR(ssr, item, tripDtls, index);
          adultssr.push(ssrinfo);
        }
      });

      adtpsgrInfo.ssrDetails = adultssr;
      adtpsgrInfo.ancillaryServices = psgr.adultDetails.ancillaryServices;
      if (psgr.adultDetails.phonecode != undefined && psgr.adultDetails.email != undefined) {
        adtpsgrInfo.phoneCountryISO2 = psgr.adultDetails.phonecode.value;
        // adtpsgrInfo.mobileNumber =
        //   psgr.adultDetails.phonecode.phonecode + "-" + psgr.adultDetails.phone;
        if (psgr.adultDetails.phonecode != undefined) {
          adtpsgrInfo.mobileNumber = psgr.adultDetails.phonecode.value + "-" + psgr.adultDetails.phone;
        } else {
          adtpsgrInfo.mobileNumber = psgr.phonecode + "-" + psgr.phone;
        }
        adtpsgrInfo.mailId = psgr.adultDetails.email;
      }

      if (adultTicketPriceArray && adultTicketPriceArray.length > 0) {
        if (adultTicketPriceArray && adultTicketPriceArray[0]?.totalFareAmount) {
          let adt_ticket_price_per_psgr = adultTicketPriceArray[0].totalFareAmount;
          adtpsgrInfo.ticketPrice = parseFloat(adt_ticket_price_per_psgr.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
        }

        if (adultTicketPriceArray && adultTicketPriceArray[0]?.totalTaxAmount) {
          let adt_ticket_tax_per_psgr = adultTicketPriceArray[0].totalTaxAmount;
          adtpsgrInfo.ticketTax = parseFloat(adt_ticket_tax_per_psgr.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
        }
      }

      let infpsgrInfo = new PassengerInfo();
      infpsgrInfo.firstName = psgr.infantDetails.firstname;
      infpsgrInfo.surname = psgr.infantDetails.lastname;
      infpsgrInfo.middlename = psgr?.infantDetails?.middlename;

      infpsgrInfo.gender = psgr.infantDetails.gender == 1 ? "male" : "female";
      infpsgrInfo.dob = psgr.infantDetails.dob;
      infpsgrInfo.knownTravelerNumber = psgr?.infantDetails?.knownTravelerNumber;
      infpsgrInfo.ktnIssuedCountry = psgr?.infantDetails?.ktnIssuedCountry;

      if (psgr.infantDetails.passport) {
        infpsgrInfo.passportNumber = psgr.infantDetails.passport;
        infpsgrInfo.passportExpiryDate = psgr.infantDetails.passportexpirydate;
        infpsgrInfo.passportIssuePlace = psgr.infantDetails.passportissue;
        infpsgrInfo.nationality = psgr.infantDetails.nationality;
      } else {
        if (bookDetailObj.supplierCode == "TF") {
          infpsgrInfo.nationality = location.countryCode ? location.countryCode : "US";
        }
      }

      /* Meal and Wheel Chair SSR Info */
      let infssr = [];
      psgr.infantDetails.specialservices.forEach((item, index) => {
        if ((item.mealtype != "" && item.mealtype != null) || (item.wheelchairtype != "" && item.wheelchairtype != null) || (item.seatNo != "" && item.seatNo != null)) {
          let ssr = new SSRDetails();
          let ssrinfo = ssr.prepareSSR(ssr, item, tripDtls, index);
          infssr.push(ssrinfo);
        }
      });

      infpsgrInfo.ssrDetails = infssr;
      infpsgrInfo.ancillaryServices = psgr.infantDetails.ancillaryServices || [];

      // infpsgrInfo.phoneCountryISO2 = psgr.infantDetails.phonecode;
      // infpsgrInfo.mobileNumber = psgr.infantDetails.phonecode + '-' + psgr.infantDetails.phone;
      if (infantTicketPriceArray && infantTicketPriceArray[0]?.totalFareAmount) {
        let inf_ticket_price_per_psgr = infantTicketPriceArray[0].totalFareAmount != undefined ? infantTicketPriceArray[0].totalFareAmount : 0;
        infpsgrInfo.ticketPrice = parseFloat(inf_ticket_price_per_psgr.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
      }

      if (infantTicketPriceArray && infantTicketPriceArray[0]?.totalTaxAmount) {
        let inf_ticket_tax_per_psgr = infantTicketPriceArray[0].totalTaxAmount != undefined ? infantTicketPriceArray[0].totalTaxAmount : 0;
        infpsgrInfo.ticketTax = parseFloat(inf_ticket_tax_per_psgr.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
      }

      Object.keys(adtpsgrInfo).forEach((key) => {
        if (key === "knownTravelerNumber") return;
        if (key === "ktnIssuedCountry") return;
        if (adtpsgrInfo[key] === "" || adtpsgrInfo[key] === null || adtpsgrInfo[key] === undefined) {
          delete adtpsgrInfo[key];
        }
      });
      Object.keys(infpsgrInfo).forEach((key) => {
        if (key === "knownTravelerNumber") return;
        if (key === "ktnIssuedCountry") return;
        if (infpsgrInfo[key] === "" || infpsgrInfo[key] === null || infpsgrInfo[key] === undefined) {
          delete infpsgrInfo[key];
        }
      });

      if (isLeadTravellerWithInf) {
        adtpsgrInfo.IsLeadTraveller = isLeadTravellerWithInf;
      } else {
        adtpsgrInfo.IsLeadTraveller = isLeadTravellerWithInf;
      }

      isLeadTravellerWithInf = false;

      model.passengerList.adultWithInfantDetails.push({
        adultDetails: adtpsgrInfo,
        infantDetails: infpsgrInfo,
      });
    }
    return model;
  }
}

export class FareRulesFareBasis {
  "fareBasis"?: string;
  "govCarrier"?: string;
  "fareComponentBeginAirport"?: string;
  "fareComponentEndAirport"?: string;
}

export class PassengersDetails {
  adultDetails: Array<PassengerInfo> = [];
  childDetails: Array<PassengerInfo> = [];
  adultWithInfantDetails: Array<any> = [];
}

export class PassengerInfo {
  knownTravelerNumber: string;
  ktnIssuedCountry: string;
  middlename: string;
  gender: string;
  surname: string;
  firstName: string;
  dob: Date;
  passportNumber?: string;
  passportExpiryDate?: Date;
  passportIssuePlace?: string;
  phoneCountryISO2?: string;
  mobileNumber: string;
  mailId: string;
  nationality: string;
  mealType: string;
  wheelChairType: string;
  ticketPrice: number;
  ticketTax: number;
  ssrDetails: Array<SSRDetails> = [];
  ancillaryServices: Array<BaggageAncillaryBooking> = [];
  IsLeadTraveller: boolean;
  emergencyPhoneNumber: string;
  emergencyPhoneISO2: string;
  emergencyEmailID: string;
  emergencyRelationCode: number;
  emergencyFirstName: string;
  emergencyLastName: string;
}

export class CustomerAddress {
  userId: string;
  addressCode: number;
  city: string;
  stateCode: string;
  postalCode: string;
  countryISO2: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  additionalComments: string;
  company: string;
  countryName: string;
  stateName: string;

  prepareCustomerAddress(addrModel: CustomerAddress, addressObj, userobj) {
    // let userobj = JSON.parse(localStorage.getItem('UserObj'));
    addrModel.userId = userobj != null && userobj != undefined ? userobj.userName : null;
    addrModel.city = addressObj.address.city;
    addrModel.stateCode = addressObj.address.state;
    addrModel.countryISO2 = addressObj.address.country;
    addrModel.postalCode = addressObj.address.zipcode;
    addrModel.addressCode = addressObj.type;
    addrModel.addressLine1 = addressObj.address.addressline1;
    addrModel.addressLine2 = addressObj.address.addressline2;
    addrModel.addressLine3 = addressObj.address.addressline3;
    addrModel.additionalComments = "test";
    addrModel.company = addressObj.address.company;
    addrModel.countryName = addressObj.address.countryName;
    addrModel.stateName = addressObj.address.stateName;

    return addrModel;
  }
}

export class CreditCard {
  cardNumber: string;
  expirationDate: string;
  cardCode: string;
  nameOnCard: string;
  cardType: string;
}

export class RazorPaymentOptions {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}

export class BookingPayment {
  razor: RazorPaymentOptions;
  discountApplied: number;
  payPalPaymentID: string;
  ytbPaymentTotalCharge: number;
  ytbPaymentTotalTax: number;
  processingFee: number;
  markupCurrencyCode: string;
  paymentCurrencyCode: string;
  paymentMethodType: number;
  paymentSupplierType: string;
  creditCard: CreditCard;
  ccInfo: string;
  payerID: string;
  isPercentage: boolean;
  isDiscountPercentage: boolean;
  pgChargedAmount: string;
  pgChargedCurrency: string;
  pgConvertionRate: string;
  discountFee: number;
  ytbPaymentTotalBase: number;
  ytbCouponCode: string;
  ytbCouponValue: number;
  ytbCouponcurrency: string;
  ytbCouponStatusCode: number;
  totalAmountWithOutCoupon: number;
  isCouponAlreadyAssigned: boolean;
  couponId: number;
  ytbCouponAmount: number;
  razorpay_payment_id: any;
  razorpay_order_id: any;
  razorpay_signature: any;
  razorPaymentID: string;
  orderId: string;
  paymentSignature: string;
  conversionValue: number;
  conversionCurrencyCode: string;
  conversionRate: any;
  fromConversionRate: any;
  toConversionRate: any;
  fromConversionCurrencyCode: any;
  toConversionCurrencyCode: any;

  createBookingPayment(model: BookingPayment, fareDetails, currency, paymentType, couponObj = null) {
    model.discountApplied = 0;
    model.ytbPaymentTotalCharge = parseFloat(fareDetails.totalFareAmount.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
    model.ytbPaymentTotalTax = parseFloat(fareDetails.totalTaxAmount.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]);
    let baseprice = Math.abs(model.ytbPaymentTotalCharge - model.ytbPaymentTotalTax);
    let fractionNumbers = baseprice.toString().split(".")[1];

    if (fractionNumbers != undefined) {
      if (fractionNumbers[2] == "9") {
        model.ytbPaymentTotalBase = parseFloat(baseprice.toFixed(2));
      } else {
        model.ytbPaymentTotalBase = baseprice;
      }
    } else {
      model.ytbPaymentTotalBase = baseprice;
    }

    model.processingFee = fareDetails.processingFee;
    model.markupCurrencyCode = currency;
    model.paymentCurrencyCode = currency;
    model.isPercentage = fareDetails.isPercentage;
    model.isDiscountPercentage = fareDetails.isDiscountPercentage;
    model.discountFee = fareDetails.discountFee;
    if (paymentType && paymentType.razor) {
      // PaymentType Data Type    String
      model.payerID = paymentType.razor.razorpay_payment_id; // Payment
      model.orderId = paymentType.razor.razorpay_order_id;
      model.paymentSignature = paymentType.razor.razorpay_signature;
    } else if (paymentType && paymentType.paypal) {
      model.payPalPaymentID = paymentType.paypal.paymentId;
      model.payerID = paymentType.paypal.payerID;
      model.paymentMethodType = 3;
      model.paymentSupplierType = "PP";
      model.pgChargedAmount = paymentType.paypal.pgChargedAmount;
      model.pgChargedCurrency = paymentType.paypal.pgChargedCurrency;
      model.pgConvertionRate = paymentType.paypal.pgConvertionRate;
    } else {
      model.payPalPaymentID = "";
      model.paymentMethodType = 1;
      model.paymentSupplierType = "CC";
    }
    if (couponObj != null && couponObj != undefined) {
      // if (!couponObj.isFlightCoupon) {
      model.ytbCouponStatusCode = couponObj["statusCode"];
      model.ytbCouponValue = couponObj["couponValue"];
      model.ytbCouponAmount = couponObj["discountApplied"];
      model.ytbCouponcurrency = couponObj["currency"];
      model.ytbCouponCode = couponObj["couponCode"];
      model.couponId = couponObj["couponId"];
      model.isCouponAlreadyAssigned = couponObj["isAssigned"];
      // }
      // model.totalAmountWithOutCoupon = parseFloat(fareDetails.totalFareAmount.toFixed(2));
    }

    return model;
  }
}

export class BookingDetailsRequest {
  bookingClassFareFamily?: string;
  bookingType: string;
  userId: string;
  bookingDate: Date;
  isRefund: boolean;
  bookingCreationCountryISO2: string;
  bookingSupplierCode: string;
  bookingPaymentCardType: number;
  geoPluginCode: number;
  bookingDeviceType: number;
  tempBookingNo: string;
  fareRules: string;
  tripType: string;
  noOfAdults: number;
  noOfKids: number;
  noOfInfant: number;
  bookingClass: string;
  description: string;
  frequentTravellerCode: number;
  frequentTravellerNumber: string;
  timeZone: string;
  fromLocation: Array<string> = [];
  toLocation: Array<string> = [];
  userIP: string;
  sessionId: string;
  isDomestic?: boolean;

  createBookingDetailsRequest(bookDetailRequest: BookingDetailsRequest, bookReqObj, formObj, userobj, ipaddress, isDomestic: boolean = false) {
    let flightDtls = formObj.flightDetails;

    bookDetailRequest.bookingDate = new Date();
    // let userobj = JSON.parse(localStorage.getItem('UserObj'));
    bookDetailRequest.userId = userobj != null && userobj != undefined ? userobj.userName : null;
    let location = JSON.parse(localStorage.getItem("geolocation"));
    bookDetailRequest.bookingCreationCountryISO2 = location.countryCode ? location.countryCode : "US";
    bookDetailRequest.bookingSupplierCode = bookReqObj.supplierCode;
    bookDetailRequest.bookingPaymentCardType = bookReqObj.cardType;
    bookDetailRequest.geoPluginCode = 1;
    bookDetailRequest.bookingDeviceType = 1;
    bookDetailRequest.tempBookingNo = bookReqObj.tempReferenceIdNo;
    bookDetailRequest.isRefund = bookReqObj.isRefund;
    bookDetailRequest.fareRules = bookReqObj.fareRules;
    bookDetailRequest.tripType = bookReqObj.tripDtls.tripType;
    bookDetailRequest.noOfAdults = bookReqObj.tripDtls.numberOfAdult;
    bookDetailRequest.noOfKids = bookReqObj.tripDtls.numberOfChild;
    bookDetailRequest.noOfInfant = bookReqObj.tripDtls.numberOfInfant;
    bookDetailRequest.sessionId = "1";
    bookDetailRequest.bookingClassFareFamily = formObj?.flightInfo?.fareDetails?.bookingClassFareFamily;

    // bookReqObj.tripDtls.tripType != 'MultiCity' ? flightDtls.depflight.supplierCode : flightDtls[0].depflight.supplierCode

    bookDetailRequest.bookingClass = bookReqObj.tripDtls.bookingClass.bookingClassName;

    // bookDetailRequest.bookingClass = bookReqObj.tripDtls.tripType != 'MultiCity' ? flightDtls.depflight.bookingSeatClass : flightDtls[0].depflight.bookingSeatClass;

    // bookDetailRequest.frequentTravellerCode = 1;
    // bookDetailRequest.frequentTravellerNumber = "13123";
    bookDetailRequest.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    bookDetailRequest.description = "";
    bookDetailRequest.fromLocation = bookReqObj.tripDtls.multiFrom;
    bookDetailRequest.toLocation = bookReqObj.tripDtls.multiTo;
    bookDetailRequest.userIP = ipaddress;
    bookDetailRequest.isDomestic = isDomestic;
    return bookDetailRequest;
  }
}

export class SSRDetails {
  flightNumber: string;
  seatNo: string;
  seatPrice: number;
  mealCode: string;
  wheelChairCode: string;
  wheelChairTypeCode: string;
  seatCharacteristic?: string;
  paxType: any;
  offerItemId: any;
  offerID: any;

  prepareSSR(ssrinfo: SSRDetails, splservice, tripDtls, segCnt) {
    ssrinfo.mealCode = splservice.mealtype;
    ssrinfo.wheelChairCode = splservice.wheelchairtype;
    ssrinfo.flightNumber = splservice.flightNumber;
    ssrinfo.wheelChairTypeCode = splservice.wheelchairtypecode;
    ssrinfo.seatNo = splservice.seatNo;
    ssrinfo.seatPrice = splservice.seatPrice ? splservice.seatPrice : 0;
    ssrinfo.seatCharacteristic = splservice.seatCharacteristic || "";
    ssrinfo.offerItemId = splservice.offerItemId;
    ssrinfo.paxType = splservice.paxType;
    ssrinfo.offerID = splservice.offerID;
    return ssrinfo;
  }
}

export class TFBookingDetails {
  carrierName: string;
  routingId: string;
  outwardId: string;
  returnId: string;
  paymentCardTypes: string[];
}

export class AsBookingDetails {
  fareTypes: string[] = [];
  fareRules: string;
  fareBasis: string;
  brandId: string;
}

export class AmadeusSession {
  amadeusSessionID: string;
  amadeusSequence: string;
  amadeusToken: string;
}

export class BaggageAllowance {
  flightFreeBagQuantityCode: string;
  baggageType: string;
  flightNoOfFreeBags: Number;
  bagWeightinKG: Number;
  bagWeightinPounds: Number;
  baggageDescription: string;
  segmentBaggage?: Array<any>;
}

export class AirlineCoupon {
  airlineMCOCouponCode: string;
  couponAmount: number;
  couponIssueDate: Date;
  isFlightCoupon: boolean;
  isCouponAmountGreaterthanTickAmount: boolean;

  prepareCoupon(model: AirlineCoupon, couponObj) {
    model.airlineMCOCouponCode = couponObj.couponCode;
    model.couponAmount = couponObj.isAirlineCoupon ? couponObj.mcoCouponValue : couponObj.couponValue;
    model.couponIssueDate = couponObj.issueDate;
    model.isFlightCoupon = couponObj.isAirlineCoupon;
    model.isCouponAmountGreaterthanTickAmount = couponObj.isCouponAmtGreater;
    return model;
  }
}
